/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'circle-arrows': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M22.8 20.64c.72 0 1.2.48 1.2 1.2s-.48 1.2-1.2 1.2h-6.36c-.72 0-1.2-.48-1.2-1.2v-6.36c0-.72.48-1.2 1.2-1.2s1.2.48 1.2 1.2v4.2C20.16 18 21.6 15.12 21.6 12c0-5.28-4.32-9.6-9.6-9.6-.72 0-1.2-.48-1.2-1.2S11.28 0 12 0c6.6 0 12 5.4 12 12 0 3.36-1.44 6.36-3.72 8.64h2.52zM12 21.6c.72 0 1.2.48 1.2 1.2S12.72 24 12 24C5.4 24 0 18.6 0 12c0-3.36 1.32-6.36 3.72-8.64H1.2c-.72 0-1.2-.48-1.2-1.2S.48.96 1.2.96h6.36c.72 0 1.2.48 1.2 1.2v6.36c0 .72-.48 1.2-1.2 1.2s-1.2-.48-1.2-1.2v-4.2C3.84 6 2.4 8.88 2.4 12c0 5.28 4.32 9.6 9.6 9.6z" _fill="#213F6B" fill-rule="evenodd"/>'
  }
})
